import React, { useState,useEffect,useRef } from 'react';
import { ChromePicker } from 'react-color';

const ColorPickerWrapper = (props) => {
    const pickerRef = useRef();
  const [showPicker, setShowPicker] = useState(false);
  const [color, setColor] = useState(props.color);

  useEffect(() => {
    setColor(props.color)
  }, [props.color])

  function convertObjectToRgba(color) {
    const { r, g, b, a } = color;
  
    // Validation for input values
    if (
      typeof r !== "number" || r < 0 || r > 255 ||
      typeof g !== "number" || g < 0 || g > 255 ||
      typeof b !== "number" || b < 0 || b > 255 ||
      typeof a !== "number" || a < 0 || a > 1
    ) {
      throw new Error("Invalid color object. Ensure r, g, b are 0-255 and a is 0-1.");
    }
  
    return `rgba(${r}, ${g}, ${b}, ${a})`;
  }
  

  const handleClick = () => {
    setShowPicker(!showPicker);
  };

  const handleClose = () => {
    setShowPicker(false);
  };

  const handleChange = (newColor) => {
   const val = convertObjectToRgba(newColor.rgb)
    setColor(val);
    props.onChange(val)
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (pickerRef.current && !pickerRef.current.contains(e.target)) {
        setShowPicker(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);



  return (
    <div ref={pickerRef}>
      <div
        style={{
          width: '36px',
          height: '24px',
          borderRadius: '5px',
          backgroundColor: color || "white",
          cursor: 'pointer',
          border:"2px grey solid",
          margin:"5px"
        }}
        onClick={()=>{
          if(props.disabled){

          }else{
            handleClick()
          }
        }  }
      />
      {showPicker && (
        <div style={{ position: 'absolute', zIndex: '2',right:"30px" }}>
           <ChromePicker  onChangeComplete={handleChange} color={color || "rgba(136, 114, 237, 1)"}/>
          
      
        </div>
      )}
    </div>
  );
};

export default ColorPickerWrapper;
